import { gql } from '@apollo/client';

/**
 * GraphQL query to fetch authentication providers
 * Consolidated from auth and community domains
 *
 * @see packages/bff/src/schema.gql - AuthProvidersResponse type (lines 245-248)
 */
export const GET_AUTH_PROVIDERS = gql`
  query GetAuthProviders {
    authProviders {
      providers {
        id
        name
        providerStatus
        isDefaultProvider
        authServerUrl
        tokenServerUrl
        clientId
        scopes
        responseType
        logoUrl
        providerUrl
        jwksUri
        createdAt
        createdBy
        lastModifiedAt
        lastModifiedBy
      }
      isAdmin
    }
  }
`;
